module.exports = __webpack_public_path__ + "img/disconnected.55b1888a.svg";